export default __webpack_public_path__ + "static/media/panoramix_round.63749ebf.png";